<template>
    <submission-card
        :id="submission.id"
        :text="submission.text"
        :status="submission.status"
        :image_url="submission.image_url"
        :submission_time="submission.submission_time"
        :decision_time="submission.decision_time"
        :scheduled_post_time="submission.scheduled_post_time"
        :filter_phrases="submission.filter_phrases"
        :route_truth_details="submission.route_truth_details"
        :numbered="submission.numbered ? true : false"
        :header_text="submission.header_text"
        :nsfw_probability="submission.nsfw_probability"
        :posted_time="submission.post ? submission.post.time_posted : null"
        :post_link="submission.post ? `https://facebook.com/${submission.post.fb_post_id}` : null"
        :instagram="submission.post_to_instagram ? true : false"
    ></submission-card>
</template>

<script>
import SubmissionCard from '../submissions/SubmissionCard'

export default {
    name: "SubmissionCardContainer",

    components: {
        SubmissionCard
    },

    props: {
        submission: {
            type: Object,
            required: true,
        },
    },
}
</script>